export const APP_STORE_URL = 'https://apps.apple.com/us/app/chuuchuu/id6748694096';
